const Bid = 'Bid';
const Employee = 'Employee';

const WarningType = Object.freeze({
    [Bid]: 0,
    [Employee]: 1,
});

export const WarningTypeNames = Object.freeze({
    0: 'bid',
    1: 'employee',
});

export default WarningType;
